export function LogoMark({ size = 44 }) {
  return (
    <img
      src="/logo.webp"
      alt="Just Call Paul logo mark"
      width={size}
      height={size}
      className="rounded-full"
      data-testid="logo-mark"
    />
  );
}

export default function Logo({ className = "h-12" }) {
  return (
    <img
      src="/logo.webp"
      alt="Just Call Paul — Home & Property Services, proudly U.S. Army veteran-owned"
      width={192}
      height={192}
      className={`${className} w-auto rounded-full`}
      data-testid="site-logo"
    />
  );
}

export function USFlag({ className = "h-4 w-6" }) {
  return (
    <svg viewBox="0 0 24 16" className={className} aria-label="American flag" role="img" data-testid="us-flag">
      <rect width="24" height="16" rx="1.5" fill="#B31942" />
      {[2.28, 4.57, 6.86, 9.14, 11.43, 13.71].map((y) => (
        <rect key={y} y={y} width="24" height="1.14" fill="#FFFFFF" />
      ))}
      <rect width="10" height="8" fill="#0A3161" />
      {[...Array(9)].map((_, i) => (
        <circle key={i} cx={1.4 + (i % 3) * 3.6} cy={1.6 + Math.floor(i / 3) * 2.4} r="0.55" fill="#FFFFFF" />
      ))}
    </svg>
  );
}

export function VeteranBadge({ className = "" }) {
  return (
    <span
      className={`inline-flex items-center gap-2 rounded-full border border-brand-orange/40 bg-brand-orange/10 px-4 py-1.5 text-[11px] font-bold tracking-[0.18em] text-brand-orange ${className}`}
      data-testid="veteran-badge"
    >
      <USFlag className="h-3.5 w-5 rounded-[2px]" />
      PROUDLY VETERAN-OWNED &amp; OPERATED
    </span>
  );
}
